"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialCovenantDirectInsertRecordsStruct = exports.FinancialCovenantDirectInsertRecordStruct = exports.FinancialCovenantWorkleaseModeIterable = exports.RequiredFinancialCovenantField = exports.FinancialCovenantResultIterable = void 0;
const v4_1 = require("zod/v4");
exports.FinancialCovenantResultIterable = [
    'PASS',
    'FAIL',
    'LEVEL_1_FAIL',
    'LEVEL_2_FAIL',
    'LEVEL_3_FAIL',
    'LEVEL_4_FAIL',
    'LEVEL_5_FAIL',
    'LEVEL_6_FAIL',
    'LEVEL_7_FAIL',
    'LEVEL_8_FAIL',
    'LEVEL_9_FAIL',
    'LEVEL_10_FAIL',
];
/**
 * Know we typically try to avoid utilizing "enums", but in this case,
 * since we allow intermediate fields to be any string + require these
 * specific ones to be included (i.e., can't rely on having type safety),
 * it's easier to utilize enum to reference throughout our codebase.
 */
var RequiredFinancialCovenantField;
(function (RequiredFinancialCovenantField) {
    RequiredFinancialCovenantField["FinancialCovenantReportingDate"] = "financialCovenantReportingDate";
    RequiredFinancialCovenantField["FinancialCovenantValue"] = "financialCovenantValue";
    RequiredFinancialCovenantField["FinancialCovenantResult"] = "financialCovenantResult";
})(RequiredFinancialCovenantField || (exports.RequiredFinancialCovenantField = RequiredFinancialCovenantField = {}));
exports.FinancialCovenantWorkleaseModeIterable = ['QA', 'RESULT'];
const FinancialCovenantStatusIterable = [
    'initialized',
    'success',
    'error',
];
exports.FinancialCovenantDirectInsertRecordStruct = v4_1.z.object({
    financialCovenantKey: v4_1.z.string(),
    value: v4_1.z.number(),
});
exports.FinancialCovenantDirectInsertRecordsStruct = v4_1.z.array(exports.FinancialCovenantDirectInsertRecordStruct);
//# sourceMappingURL=FinancialCovenants.js.map